<template>
	<div class="order-body">
		<Search :ids="ids" :tableData='tableData' :options="options" :customerOptions="customerOptions" :bigcategoryview='bigcategoryview' :customList="customList" :AuthorityList='AuthorityList' ref='searchRef' @handleSearch="handleSearch" @modifySuc="modifySuc"/>
		<MainTable
			ref='table'
			:size='size'
			:page='page'
			:tableData='tableData'
			:totalCount='totalCount'
			:AuthorityList='AuthorityList'
			@modifySuc="modifySuc"
			@handleSize='handleSizeChange'
			@handlePage='handlePageChange'
			@selectIds="selectIdsChange"
		/>
	</div>
</template>

<script>
import Search from '@/components/percentage/Search.vue'
import MainTable from '@/components/percentage/MainTable.vue'
export default {
	name: 'percentage',
	components: {
		Search,
		MainTable
	},
	data () {
		return {
			AuthorityList: {
				'11_0001_0001_00': false,
				'11_0002_0002_00': false
			},
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0,
			ids: [],
			customList: [],
			bigcategoryview: 0,
			disabledflag: -1,
			staff: [],
			customer: [],
			shopCategoryBigId: '0',
			shopCategorySmallId: '0',
			product: '',
			spec: '',
			plantype: -1,
			planway: -1,
			options: [],
			customerOptions: [],
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '13-1')
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		this.getSystemSet()
		this.getCategory()
		this.getAuthority('11_0001_0000_00')
		this.openPage()
	},
	methods: {
		selectIdsChange (ids) {
			this.ids = ids
		},
		saveSelect () {
			let params = {
				shopCategoryBigId: this.shopCategoryBigId,
				shopCategorySmallId: this.shopCategorySmallId,
				disabledflag: this.disabledflag,
				staff: this.staff,
				customer: this.customer,
				product: this.product,
				spec: this.spec,
				plantype: this.plantype,
				planway: this.planway,
				page: this.page,
				size: this.size
			}
			window.sessionStorage.setItem('percentSelect', JSON.stringify(params))
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		// 客户类别
		getCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result === true) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		openPage () {
			if (window.sessionStorage.getItem('percentSelect') && !this.filterFlag) {
				let data = JSON.parse(window.sessionStorage.getItem('percentSelect'))
				this.shopCategoryBigId = data.shopCategoryBigId
				this.shopCategorySmallId = data.shopCategorySmallId
				this.disabledflag = data.disabledflag
				this.staff = data.staff
				this.customer = data.customer
				this.product = data.product
				this.spec = data.spec
				this.plantype = data.plantype
				this.planway = data.planway
				this.page = data.page
				this.size = data.size
			}
			this.findOrderList()
			this.findUserName()
			this.findCustomer()
		},
		modifySuc () {
			this.$refs.table.clear()
			this.openPage()
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.findOrderList()
		},
		handlePageChange (value) {
			this.page = value
			this.findOrderList()
		},
		handleSearch (data) {
			this.shopCategoryBigId = data.shopCategoryBigId
			this.shopCategorySmallId = data.shopCategorySmallId
			this.disabledflag = data.disabledflag
			this.staff = data.staff
			this.customer = data.customer
			this.product = data.product
			this.spec = data.spec
			this.plantype = data.plantype
			this.planway = data.planway
			this.page = 1
			this.$refs.table.clear()
			if (!this.filterFlag) {
				this.saveSelect()
			}
			this.findOrderList()
		},
		getSystemSet () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					this.bigcategoryview = res.bigcategoryview
					resolve(res)
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		findOrderList () {
			this.tableData = []
			let params = {
				page: this.page,
				size: this.size,
				staffIds: this.staff,
				customerIds: this.customer,
				disabledflag: this.disabledflag,
				shopCategoryBigId: this.shopCategoryBigId,
				shopCategorySmallId: this.shopCategorySmallId,
				product: this.product,
				dealTypeId: this.dealTypeId,
				spec: this.spec,
				plantype: this.plantype,
				planway: this.planway
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/planfindlist`,
				data: params
			}).then(res => {
				this.totalCount = res.recordCount
				this.tableData = res.recordList
				this.$nextTick(() => {
					this.$refs.table.initIschoose()
				})
			})
		},
		findUserName () {
			let params = {
				userName: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/staff/getStaffInfoForCondition`,
				data: params
			}).then(res => {
				this.options = res.data
			})
		},
		findCustomer () {
			let params = {
				name: '',
				customercategoryid: '-1'
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerInfoForCondition`,
				data: params
			}).then(res => {
				this.customerOptions = res.data
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-menu {
		height: 50px
		display flex
		position relative
		border-bottom: 1px solid #dce1fe
		li {
			height: 100%
			line-height: 49px
			margin-right: 60px
			font-size: 15px
			// font-weight: 700
			box-sizing:border-box
			cursor: pointer
			position: relative
			color: #595959
			&.active {
				color: var(--fx-primary-color)
				border-bottom: 2px solid var(--fx-primary-color)
			}
			span {
				position: absolute;
				width: 18px;
				height: 18px;
				line-height: 18px;
				border-radius: 50%;
				font-size: 11px;
				top: 5px;
				right: -18px;
				text-align: center;
				background-color: #EC4141;
				color: #fff;
				&.big-num {
					width: 28px;
					border-radius: 40px;
					right: -28px;
				}
			}
		}
		div {
			height: 100%
			line-height: 49px
			font-size: 14px
			font-weight: 700
			box-sizing:border-box
			position absolute;
			top: 0;
			right: 50px;
		}
	}
}
</style>
<style lang="stylus">
.order-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
